var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnderline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 4C8.5 3.44772 8.05228 3 7.5 3C6.94772 3 6.5 3.44772 6.5 4V11C6.5 14.866 7.5 18 12.5 18C17.5 18 18.5 14.866 18.5 11V4C18.5 3.44772 18.0523 3 17.5 3C16.9477 3 16.5 3.44772 16.5 4V11C16.5 13.7614 16.5 16 12.5 16C8.5 16 8.5 13.7614 8.5 11V4Z",
    fill: "#52525B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 19C5.94772 19 5.5 19.4477 5.5 20C5.5 20.5523 5.94772 21 6.5 21H18.5C19.0523 21 19.5 20.5523 19.5 20C19.5 19.4477 19.0523 19 18.5 19H6.5Z",
    fill: "#52525B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderline);
export default __webpack_public_path__ + "static/media/Underline.58853de0152acf0abb8dad13e53bafa9.svg";
export { ForwardRef as ReactComponent };